import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductImportImagesComponent } from './components/product-import-images/product-import-images.component';
import { ProductImportTableCheckerComponent } from './components/product-import-table-checker/product-import-table-checker.component';
import { ProductImportComponent } from './containers/product-import/product-import.component';

const routes: Routes = [
  {
    path: '',
    component: ProductImportComponent,
    children: [
      {
        path: 'images',
        component: ProductImportImagesComponent,
      },
      {
        path: 'table-checker',
        component: ProductImportTableCheckerComponent,
      },
      { path: '**', redirectTo: 'images' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductImportRoutingModule {}
